import { useWindowWidth } from '@react-hook/window-size/throttled';
import I18n from 'i18n-js';

import XIcon from '~/components/atoms/Icons/XIcon';

import constants from '~/sass/consts.module.scss';

import styles from './MenuNavigationBar.module.scss';

export function MenuNavigationBar({
  onClose,
}: {
  onClose: () => void;
}): JSX.Element {
  const width = useWindowWidth();

  if (width <= Number(constants.smallMobileView)) {
    return (
      <header className={styles.mobileHeader}>
        <h6 className={styles.mobileHeading}>{I18n.t('MenuView_bc')}</h6>
        <XIcon
          onClick={onClose}
          background={false}
          className={styles.mobileClose}
        />
      </header>
    );
  }

  return (
    <XIcon
      onClick={onClose}
      className={styles.closeButton}
    />
  );
}
